"use strict";

exports.__esModule = true;
var MOBILE_MIN_WIDTH = exports.MOBILE_MIN_WIDTH = 320;
var TABLET_MIN_WIDTH = exports.TABLET_MIN_WIDTH = 768;
var DESKTOP_MIN_WIDTH = exports.DESKTOP_MIN_WIDTH = 1025;